import { useQuery } from '@tanstack/react-query';
import axios from 'axios';
import * as React from 'react';

import type { VendorSelectProps } from 'vms/common/components/VendorSelect';
import VendorSelect from 'vms/common/components/VendorSelect';

import type { PartVendor } from './types';

export const partVendorsQuery = {
  queryKey: ['part-vendors'],
  queryFn: async ({ signal }: { signal?: AbortSignal }) => {
    const response = await axios.request<PaginatedResults<PartVendor>>({
      url: '/part-vendors/',
      params: { page_size: 1000 },
      signal,
    });
    return response.data.results;
  },
};

export function PartVendorSelect(props: VendorSelectProps) {
  const { data = [], isLoading, isError, refetch } = useQuery(partVendorsQuery);
  return (
    <VendorSelect
      {...props}
      vendors={data}
      isLoading={isLoading}
      isError={isError}
      onRetry={() => refetch()}
    />
  );
}
